import React from 'react';
import PropTypes from 'prop-types';
import { ForgeIcon, ForgeIconButton } from '@tylertech/forge-react';
import './TableCellButton.scss';
import { AI_ICON_NAME } from '../../../../static/constants.js';

const TableCellButton = ({ data, handleClick, icon, disabled = false, label, id }) => {
  const buttonId = id || `icon_${data.id}_${icon}`;

  return (
    <div className="table-cell-button-container">
      <ForgeIconButton
        id={buttonId}
        className="defaultIconColor"
        onClick={() => handleClick(data)}
        disabled={disabled}
        ariaLabel={label}
      >
        {icon === AI_ICON_NAME ?
          <forge-ai-icon class={'defaultIconSize defaultIconColor'} external externalType="all" />
          :

          <ForgeIcon external externalType="all" name={icon} />
        }

      </ForgeIconButton>
    </div>
  );
};

TableCellButton.propTypes = {
  data: PropTypes.object,
  handleClick: PropTypes.func,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.string
};

export default TableCellButton;
